export const AppPermissions = {
  DEVIATIONS_DEFAULT: 'DosageDeviation.Deviations',
  SERVICE_ORDERS_DEFAULT: 'DosageDeviation.ServiceOrders',
  SERVICE_ORDERS_EDIT: 'DosageDeviation.ServiceOrders.Edit',
  SERVICE_ORDERS_DELETE: 'DosageDeviation.ServiceOrders.Delete',
  SERVICE_ORDERS_ADD: 'DosageDeviation.ServiceOrders.Add',
  SYNCHRONIZATION_DEFAULT: 'DosageDeviation.Synchronization.Sync',
};
